export const adm = {
  shell:
    'min-h-screen bg-[#07080b] bg-[radial-gradient(ellipse_80%_50%_at_50%_-12%,rgba(99,102,241,0.05),transparent_50%)]',

  main: 'text-[#e4e6ed]',

  header:
    'sticky top-0 z-40 border-b border-white/[0.06] bg-[#07080b]/80 backdrop-blur-xl backdrop-saturate-150 shadow-[0_1px_0_0_rgba(255,255,255,0.04)]',

  headerInner: 'px-4 sm:px-6 lg:px-8 py-3.5 lg:py-4 flex items-center justify-between gap-4 max-w-[1760px] mx-auto',

  titleKicker: 'text-[10px] uppercase tracking-[0.2em] text-[#818cf8]/90 font-semibold',

  title: 'text-lg sm:text-xl font-semibold tracking-tight text-[#f4f5f8]',

  linkBack:
    'inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-[#a8b0bf] transition-all hover:border-[#6366f1]/35 hover:bg-[#6366f1]/10 hover:text-[#e4e6ed]',

  contentWrap: 'px-4 sm:px-6 lg:px-8 py-6 lg:py-8 max-w-[1760px] mx-auto w-full',

  rail: 'flex flex-col gap-1 rounded-2xl border border-white/[0.06] bg-[#0a0c11]/80 p-2 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.04)]',

  railLabel: 'px-3 pt-2 pb-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-[#5c6370]',

  navItem:
    'group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200',

  navActive:
    'bg-gradient-to-r from-[#6366f1]/12 to-transparent text-[#f4f5f8] shadow-[inset_3px_0_0_0_#818cf8]',

  navInactive: 'text-[#8b92a1] hover:bg-white/[0.04] hover:text-[#e4e6ed]',

  navIcon: 'h-4 w-4 shrink-0 opacity-80',

  panel:
    'rounded-2xl border border-white/[0.06] bg-[#0c0e14]/90 shadow-[0_8px_32px_-12px_rgba(0,0,0,0.55),inset_0_1px_0_0_rgba(255,255,255,0.04)]',

  panelHeader: 'border-b border-white/[0.06] px-4 py-3 bg-[#080a0f]/60',

  panelTitle: 'text-[11px] font-semibold uppercase tracking-[0.14em] text-[#7d8696]',

  statCard:
    'rounded-xl border border-white/[0.08] bg-[#0a0c11] p-4 transition-colors hover:border-white/[0.12]',

  cardClickable: 'block cursor-pointer text-left w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6366f1]/35',

  statLabel: 'text-[11px] font-medium uppercase tracking-[0.12em] text-[#7d8696]',

  statValue: 'mt-2 text-2xl font-semibold tabular-nums tracking-tight text-[#f4f5f8]',

  statSub: 'mt-1 text-[11px] text-[#6b7288]',

  statIconWrap:
    'flex h-9 w-9 items-center justify-center rounded-xl border border-white/[0.06] bg-[#6366f1]/10 text-[#a5b4fc]',

  input:
    'w-full rounded-xl border border-white/[0.08] bg-[#080a0f]/80 px-3 py-2.5 text-sm text-[#e4e6ed] placeholder:text-[#5c6370] shadow-inner shadow-black/20 transition-colors focus:border-[#6366f1]/45 focus:outline-none focus:ring-2 focus:ring-[#6366f1]/20',

  pillInactive:
    'border border-white/[0.08] bg-[#080a0f]/60 text-[#9ca3b8] hover:border-white/[0.12] hover:bg-white/[0.03]',

  pillActive:
    'border border-[#818cf8]/40 bg-[#6366f1]/20 text-[#e4e6ed] shadow-[0_0_24px_-8px_rgba(99,102,241,0.45)]',

  btnPrimary:
    'rounded-xl bg-gradient-to-b from-[#818cf8] to-[#6366f1] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_4px_20px_-4px_rgba(99,102,241,0.55)] transition hover:brightness-110 active:scale-[0.98]',

  btnGhost:
    'rounded-xl border border-white/[0.1] px-4 py-2.5 text-sm font-medium text-[#a8b0bf] transition hover:border-white/[0.16] hover:bg-white/[0.04] hover:text-[#e4e6ed]',

  tableWrap: 'overflow-x-auto',

  tableHead: 'text-left text-[10px] font-semibold uppercase tracking-[0.12em] text-[#6b7288]',

  tableRow: 'border-b border-white/[0.04] transition-colors hover:bg-white/[0.03]',

  tableCell: 'px-4 py-2.5 text-[13px] text-[#c8cdd8]',

  link: 'font-medium text-[#93a4ff] transition hover:text-[#b4c2ff]',

  sectionLabel: 'mb-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#5c6370]',

  chartCard:
    'rounded-2xl border border-white/[0.06] bg-[#0a0c11]/90 p-4 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.04)]',

  chartTitle: 'mb-4 text-xs font-semibold text-[#9ca3b8]',
} as const;
